import React, { useMemo } from "react";
import { motion } from "framer-motion/dist/framer-motion";
import { useTranslation } from "react-i18next";
import PageTitle from "@components/Common/PageTitle";
import { StyledBreadcrumb } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { store as userStore } from "@components/VerticalLayout/store";
import { CARD_MENU_LIST } from "./CardMenuList";
import CardMenu from "@helpers/CardMenus";
import { getPathAuthorization } from "@components/VerticalLayout";
import { useSelector } from "react-redux";


interface GlobalState {
    selectedAccount: string;
    infoUser: {
        profileAuthorization: any[];
    };
}

export function Pos() {
    const { t } = useTranslation();
    const { oneShop } = useSnapshot(userStore);
    const selectedAccount = useSelector(
        (state: { global: GlobalState }) => state.global.selectedAccount
    );
    const authorizationList = useSelector(
        (state: { global: GlobalState }) =>
            state.global.infoUser.profileAuthorization
    );

    const breadcrumbItems = useMemo(
        () => [
            {
                item: "Settings".toUpperCase(),
                link: `${process.env.REACT_APP_PORTAIL_URL}`,
            },
            {
                item: selectedAccount?.toUpperCase() || "",
                link: oneShop ? "/setting/customer-account" : "/compte",
            },
            {
                item: t("Application").toUpperCase(),
                link: "applications",
            },
            {
                item: t("POS").toUpperCase(),
                link: "#",
            },
        ],
        [t, selectedAccount, oneShop]
    );
    return (
        <React.Fragment>
            <PageTitle title={"Applications"} />
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 1 }}
                className="page-content__clz"
            >
                <StyledBreadcrumb items={breadcrumbItems} />
                <div className="row p-4">
                <div className="row p-4">
                    {CARD_MENU_LIST.filter(
                        (cardMenu: any) =>
                            getPathAuthorization(
                                cardMenu.path,
                                authorizationList
                            ).Visible === true
                    ).map((cardMenu: any, index: number) => (
                        <CardMenu
                            key={index}
                            title={t(cardMenu.title).toUpperCase()}
                            number={cardMenu.number}
                            Icon={cardMenu.Icon}
                            description={t(cardMenu.description)}
                            path={cardMenu.path}
                            numberKiosk="0" // Kept as string 0 based on original
                        />
                    ))}
                </div>
                </div>
            </motion.div>
        </React.Fragment>
    );
}
